const LeadershipAndGovernanceScreen = () => {

    return(
        <p>Leadership and Governance</p>
    )
    
}

export default LeadershipAndGovernanceScreen